define(function levelsConfig() {
  'use strict';

  function gettext(phrase) {
    return phrase;
  }

  var maps = {
    groupReadingLevels: {
      displayNamesArray: [
        gettext('Grade Level'),
        gettext('Guided Reading'),
        gettext(`Accelerated Reader${String.fromCharCode(174)}`)
      ],
      groupLevelTypeToOptionsMap: {
        grade_level: 'gradeOptions',
        guided_level: 'guidedReadingOptions',
        accelerated_reader_level: 'acceleratedReaderLevel'
      },
      camelToCamel: {
        guidedLevel: 'guidedLevel',
        lexileLevel: 'lexileLevel',
        gradeLevel: 'gradeLevel',
        acceleratedReaderLevel: 'acceleratedReaderLevel'
      },
      camelToSnake: {
        guidedLevel: 'guided_level',
        gradeLevel: 'grade_level',
        acceleratedReaderLevel: 'accelerated_reader_level'
      },
      snakeToSnake: {
        grade_level: 'grade_level',
        guided_reading: 'guided_level',
        accelerated_reader: 'accelerated_reader_level'
      }
    },
    groupLevelTypesObj: {
      grade_level: {
        id: '1',
        label: gettext('Grade Level'),
        value: 'grade_level'
      },
      guided_level: {
        id: '2',
        label: gettext('Guided Reading'),
        value: 'guided_level'
      },
      accelerated_reader_level: {
        id: '4',
        label: gettext(`Accelerated Reader${String.fromCharCode(174)}`),
        value: 'accelerated_reader_level'
      }
    },
    gradeLevelDecoratorMap: {
      576: {color: '#ffa600'},
      577: {color: '#a5c909'},
      578: {color: '#46b717'},
      579: {color: '#41b8bb'},
      580: {color: '#4695e6'},
      581: {color: '#4456aa'},
      582: {color: '#9265d3'},
      583: {color: '#a547b7'},
      584: {color: '#be4a86'}
    },
    validAssessGradeLevelMap: {
      576: [577],
      577: [578, 577],
      578: [579, 578, 577],
      579: [580, 579, 578],
      580: [581, 580, 579],
      581: [582, 581, 580],
      582: [583, 582, 581],
      583: [584, 583, 582],
      584: [584, 583]
    }
  };

  var getReadingLevelOptionsMap = function getReadingLevelOptionsMap(options) {
    var readingLevelOptionsMap = {};
    options.forEach(function(levelTag) {
      readingLevelOptionsMap[levelTag.tagId] = levelTag;
    });
    return readingLevelOptionsMap;
  };

  return {
    maps: maps,
    getReadingLevelOptionsMap: getReadingLevelOptionsMap
  };
});
